import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ari10logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-9bba6f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Make Payment", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Your order have to ba pain in 24 hours, after this time it will be automatically canceled", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please use ARI10 gateway to pay your order", -1 /* HOISTED */))
const _hoisted_7 = { class: "payment_container__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your order info", -1 /* HOISTED */))
const _hoisted_9 = { class: "box-shadow summary" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"30px"},
  src: _imports_0
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, "Your order no. " + _toDisplayString($setup.transactionContextStore.orderId) + " has been placed successfully", 1 /* TEXT */),
    _hoisted_3,
    _hoisted_4,
    _createTextVNode(),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, "Amount of C4E: " + _toDisplayString($setup.transactionContextStore.amountToBuy.amount), 1 /* TEXT */),
        _createElementVNode("div", null, "Amount of " + _toDisplayString($setup.transactionContextStore.paymentCurrency) + ": " + _toDisplayString($setup.transactionContextStore.amountToPay.amount) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency), 1 /* TEXT */),
        _createElementVNode("div", null, "Current exchange rate: 1 C4E = " + _toDisplayString($setup.transactionContextStore.exchangeRate.toFixed(5)) + " " + _toDisplayString($setup.transactionContextStore.paymentCurrency), 1 /* TEXT */)
      ]),
      _createVNode(_component_Button, {
        class: "secondary",
        onClick: $setup.onPay
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createTextVNode("GO TO ARI10 PAYMENT GATEWAY ")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}